import type { FrameSpec } from '../config/frames';

const LOCALES = new Set(['fr','id','de','es','it','nl','pt','ru','zh','ja','ko','ar','hi','ms']);

/** Signature colourways are finished products. Handmade retains the order panel. */
export function signatureProductHref(
  frame: Pick<FrameSpec, 'id' | 'line' | 'productHandle'>,
  initialFrameId: string,
  initialProductHandle: string | undefined,
  language: string,
): string | null {
  if (frame.line !== 'Classic') return null;
  const handle = frame.id === initialFrameId && initialProductHandle ? initialProductHandle : frame.productHandle;
  if (!handle || !/^[a-z0-9-]+$/i.test(handle)) return null;
  const locale = language.toLowerCase().split('-')[0] || 'en';
  const prefix = LOCALES.has(locale) ? `/${locale}` : '';
  return `https://maisonmata.com${prefix}/products/${encodeURIComponent(handle)}`;
}
